import {authPost} from "plugins/api/helpers"

export const trackEvent = async (
  name: string,
  options: Record<string, number | string> = {},
) => {
  await authPost(`/api/event`, {name, options})
}
